var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 212,
    viewBox: "0 0 390 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 170.325L9 155.829C19 141.333 37 112.342 56 108.718C74 106.906 93 126.838 111 130.462C130 134.085 149 119.59 167 112.342C186 106.906 204 106.906 223 115.966C241 126.838 260 148.581 279 148.581C297 148.581 316 126.838 334 99.6581C353 70.6667 371 36.2393 381 18.1197L390 0V212H381C371 212 353 212 334 212C316 212 297 212 279 212C260 212 241 212 223 212C204 212 186 212 167 212C149 212 130 212 111 212C93 212 74 212 56 212C37 212 19 212 9 212H0V170.325Z",
    fill: "#51CDA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopWave);
export default __webpack_public_path__ + "static/media/desktopWave.956f80cff4eefc8a8542550c30641531.svg";
export { ForwardRef as ReactComponent };